import { render, staticRenderFns } from "./ServiceType.vue?vue&type=template&id=fa47b0f2&scoped=true&"
import script from "./ServiceType.vue?vue&type=script&setup=true&lang=js&"
export * from "./ServiceType.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./ServiceType.vue?vue&type=style&index=0&id=fa47b0f2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa47b0f2",
  null
  
)

export default component.exports